var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.$l10n.__("Gérer le pied de page des documents")))
      ]),
      _vm._v(" "),
      _c(
        "el-radio-group",
        {
          staticClass: "flex-column ovy-hidden",
          attrs: { value: _vm.value },
          on: { input: _vm.handleFooterAuto }
        },
        [
          _c("el-radio", { staticClass: "mb-2", attrs: { label: true } }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Gérer automatiquement le pied de page selon les informations renseignées"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("el-radio", { attrs: { label: false } }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Gérer manuellement le pied de page des documents"
                  )
                ) +
                "\n        "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.footerAuto,
              expression: "!footerAuto"
            }
          ]
        },
        [
          _vm.langs.length > 1
            ? _c(
                "el-tabs",
                { staticClass: "mt-3", attrs: { type: "border-card" } },
                _vm._l(_vm.langs, function(lang) {
                  return _c(
                    "el-tab-pane",
                    { key: lang.label, attrs: { label: lang.label } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "pt-3 block",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          lang.flag === "fa-flag"
                            ? _c("i", { staticClass: "fa", class: lang.flag })
                            : _c("img", {
                                attrs: {
                                  src:
                                    "/ressources/public/img/flags/" +
                                    (lang.flag ? lang.flag : "blank") +
                                    ".png",
                                  alt: lang.flag
                                }
                              }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(lang.label) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("RichText", {
                        staticClass: "custom-richtext",
                        attrs: { options: _vm.optionsRichText },
                        model: {
                          value: lang.content,
                          callback: function($$v) {
                            _vm.$set(lang, "content", $$v)
                          },
                          expression: "lang.content"
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _c("RichText", {
                staticClass: "custom-richtext richtext-alone",
                attrs: { options: _vm.optionsRichText },
                model: {
                  value: _vm.langs[0].content,
                  callback: function($$v) {
                    _vm.$set(_vm.langs[0], "content", $$v)
                  },
                  expression: "langs[0].content"
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }